export default {"src":"/_next/static/media/features-most-secure-platform.66bdc885.svg","height":59,"width":58,"blurWidth":0,"blurHeight":0};